import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-announcement-bar',
  templateUrl: './announcement-bar.component.html',
  styleUrls: ['./announcement-bar.component.scss']
})
export class AnnouncementBarComponent {
  @Input() message = $localize`:@@shell.announcement:Enjoy free delivery on orders of HK$1400+*`;
}
